/*! Infinite Grid Init - keyset + IntersectionObserver */
(function () {
  "use strict";
  var global = window;

  function escapeHtml(s) {
    return (s || "").replace(/[&<>"']/g, m => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#039;" }[m]));
  }
  function fmtNum(n) { n = Number(n || 0); return n.toLocaleString('th-TH'); }
  function formatPrice(minp, maxp, unit) {
    minp = Number(minp || 0); maxp = Number(maxp || 0);
    if (minp > 0 || maxp > 0) return `${fmtNum(minp)} - ${fmtNum(maxp)} ${escapeHtml(unit || '')}`;
    return 'สอบถามราคา';
  }

  function buildCardHTML(r) {
    return `
      <a href="more.php?product_id=${r.id}&store_name=${encodeURIComponent(r.business_name||'')}&username=${encodeURIComponent(r.username||'')}" class="text-decoration-none">
        <div class="card h-100 border-0 shadow rounded-4">
          <img class="card-img-top" loading="lazy" src="${r.file_url}" alt="">
          <div class="card-body d-flex flex-column">
            <h5 class="card-title text-black fw-bold fs-20">${escapeHtml(r.productname||'')}</h5>
            <div class="card-text">
              <p class="text-warning fw-bold">${formatPrice(r.minprice, r.maxprice, r.unitprice)}</p>
              <span class="fs-12 fw-bold"> สั่งขั้นต่ำ </span>
              <span class="text-dark fs-12 fw-bold">${fmtNum(r.minbuy)} ${escapeHtml(r.unitbuy||'')}</span>
              <p class="text-dark text-uppercase fs-12 mb-1">${escapeHtml(r.business_name||'')}</p>
            </div>
            <p class="text-dark text-uppercase fs-12 mt-auto mb-0">${escapeHtml(r.province||'')}</p>
          </div>
          <div class="d-grid px-3 pb-3">
            <button class="btn btn-product rounded-pill fs-md-16 text-white fs-12 px-4">รายละเอียดสินค้า</button>
          </div>
        </div>
      </a>`;
  }

  async function fetchBatch({ apiPath, sub, cat, store, limit, afterId }) {
    const url = new URL(apiPath, location.href);
    if (sub)     url.searchParams.set('sub', sub);
    if (cat)     url.searchParams.set('cat', cat);
    if (store)   url.searchParams.set('store', store);
    url.searchParams.set('limit', limit);
    if (afterId) url.searchParams.set('after_id', afterId);
    const res = await fetch(url.toString(), { cache: 'no-store' });
    if (!res.ok) throw new Error('Network error');
    return res.json();
  }

  function setHeightsFromDataset(container) {
    const useScrollbar = container.dataset.scrollbar === 'true';
    const maxvh = container.dataset.maxvh;
    container.style.minHeight = '0';
    if (useScrollbar) {
      container.style.maxHeight = maxvh ? `${parseInt(maxvh, 10)}vh` : 'none';
      container.style.overflowY = 'auto';
      container.style.overflowX = 'hidden';
    } else {
      container.style.maxHeight = 'none';
      container.style.overflowY = 'visible';
      container.style.overflowX = 'visible';
    }
  }

  function initInfinite(container, opts) {
    const sentinel = container.querySelector('.io-sentinel');
    // loader อยู่นอก row (ใน parent) เพื่อให้ absolute center ได้
    const loader   = container.querySelector('.loader') || (container.parentElement && container.parentElement.querySelector('.loader'));
    const noMore   = container.querySelector('.no-more');

    const sub   = container.dataset.sub   ? parseInt(container.dataset.sub,   10) : null;
    const cat   = container.dataset.cat   ? parseInt(container.dataset.cat,   10) : null;
    const store = container.dataset.store || null;

    const isTablet = matchMedia('(min-width: 577px) and (max-width: 991px)').matches;
    const isMobile = matchMedia('(max-width: 576px)').matches;
    const LIMIT = isMobile
      ? Number(container.dataset.limitMobile  || opts.mobileLimit)
      : isTablet
        ? Number(container.dataset.limitTablet  || opts.tabletLimit)
        : Number(container.dataset.limitDesktop || opts.desktopLimit);

    const apiPath      = container.dataset.api || opts.apiPath;
    const useScrollbar = container.dataset.scrollbar === 'true';

    const seen = new Set(
      Array.from(container.querySelectorAll('[data-card][data-id]'))
           .map(el => parseInt(el.getAttribute('data-id'), 10))
           .filter(Boolean)
    );

    let afterId = container.dataset.afterId
      ? parseInt(container.dataset.afterId, 10)
      : (() => {
          const cards = container.querySelectorAll('[data-card][data-id]');
          return cards.length ? cards[cards.length - 1].getAttribute('data-id') : null;
        })();
    afterId = afterId ? Number(afterId) : null;

    let loading = false;
    let done    = false;

    setHeightsFromDataset(container);

    // sentinel observer — ใช้ container เป็น root ถ้า scrollbar=true
    const observerRoot = useScrollbar ? container : null;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) load(); });
    }, { root: observerRoot, rootMargin: '0px', threshold: 0 });

    async function load() {
      if (loading || done) return;
      loading = true;
      container.classList.add('is-loading');
      if (loader) loader.style.display = 'flex';
      container.querySelectorAll('.skeleton-card').forEach(el => el.remove());
      if (sentinel) io.unobserve(sentinel);

      // spinner แสดงอย่างน้อย 400ms
      const spinnerStart = Date.now();
      const minSpinner = () => {
        const elapsed = Date.now() - spinnerStart;
        return elapsed < 400 ? new Promise(r => setTimeout(r, 400 - elapsed)) : Promise.resolve();
      };

      try {
        const [json] = await Promise.all([
          fetchBatch({ apiPath, sub, cat, store, limit: LIMIT, afterId }),
          minSpinner()
        ]);
        const items = json.items || [];

        if (!items.length) {
          done = true;
          container.classList.add('is-done');
          if (noMore) noMore.style.display = 'block';
          return;
        }

        const frag = document.createDocumentFragment();
        let lastId = null;

        for (const r of items) {
          const rid = Number(r.id);
          if (!rid || seen.has(rid)) continue;
          seen.add(rid);
          lastId = rid;
          const col = document.createElement('div');
          col.className = 'col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-6';
          col.setAttribute('data-card', '');
          col.setAttribute('data-id', String(rid));
          col.innerHTML = buildCardHTML(r);
          frag.appendChild(col);
        }

        if (frag.childNodes.length === 0) {
          const minId = Math.min(...items.map(r => Number(r.id)));
          if (minId && minId < (afterId || Infinity)) {
            afterId = minId;
          } else {
            done = true;
            container.classList.add('is-done');
            if (noMore) noMore.style.display = 'block';
          }
        } else {
          container.insertBefore(frag, sentinel);
          afterId = lastId;
        }
      } catch (e) {
        console.error(e);
      } finally {
        loading = false;
        container.classList.remove('is-loading');
        if (loader) loader.style.display = 'none';
        if (!done && sentinel) {
          setTimeout(() => { if (!done) io.observe(sentinel); }, 100);
        }
      }
    }

    if (useScrollbar) {
      const idx = Array.from(document.querySelectorAll('.product-category[data-infinite="true"]')).indexOf(container);
      setTimeout(() => load(), idx * 300);
    } else {
      if (sentinel) io.observe(sentinel);
    }
  }

  function initAll(options) {
    const opts = Object.assign({
      apiPath:      'api_products.php',
      mobileLimit:  2,
      tabletLimit:  3,
      desktopLimit: 4
    }, options || {});
    document.querySelectorAll('.product-category[data-infinite="true"]')
            .forEach(c => initInfinite(c, opts));
  }

  if (typeof window !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.InfiniteGridAutoInit === false) return;
      initAll(window.InfiniteGridOptions || {});
    });
  }

  global.InfiniteGridInitAll = initAll;

})(window);